import React, { forwardRef } from "react";

const Textarea = forwardRef(
  ({ label, helper, error, className = "", required, ...props }, ref) => {
    return (
      <label className="flex flex-col gap-2 text-sm text-slate-600 dark:text-slate-400">
        <span>
          {label}
          {required ? <span className="ml-1 text-rose-600">*</span> : null}
        </span>
        <textarea
          ref={ref}
          className={[
            "min-h-[96px] rounded-lg border px-4 py-3 text-base text-slate-900 dark:text-slate-100 bg-white dark:bg-slate-700 shadow-sm",
            "outline-none transition",
            error
              ? "border-rose-300 dark:border-rose-600 focus:border-rose-400 dark:focus:border-rose-500"
              : "border-slate-200 dark:border-slate-600 focus:border-slate-400 dark:focus:border-slate-500",
            className,
          ]
            .filter(Boolean)
            .join(" ")}
          required={required}
          {...props}
        />
        {helper && !error && (
          <span className="text-xs text-slate-500 dark:text-slate-400">
            {helper}
          </span>
        )}
        {error && (
          <span className="text-xs text-rose-600 dark:text-rose-400">
            {error}
          </span>
        )}
      </label>
    );
  },
);

export default Textarea;
